export default "__VITE_ASSET__a1f00ba1__"